import { cn } from '@/lib/utils';
import { Plus } from 'lucide-react';
import React, { useState } from 'react'
import { VoiceAddModal } from './voice-add-model';

interface VoiceAddButtonProps {
  className?: string;
  voiceIds?: string[];
  saveLoading?: boolean;
  onSave?: (voiceIds: string[]) => Promise<void>;
}

/* 语音添加按钮 */
export const VoiceAddButton: React.FC<VoiceAddButtonProps> = ({
  className,
  voiceIds = [],
  saveLoading = false,
  onSave,
}) => {
  const [open, setOpen] = useState(false);

  const onSaveVoice = async (voiceIds: string[]) => {
    await onSave?.(voiceIds);
  };

  return (
    <>
      <button
        className={cn(
          "w-full h-[76px] flex items-center justify-center bg-[#F2F4F7] rounded-[12px] border transition-colors border-[rgba(233,234,235,1)] hover:bg-[rgba(234,236,240,1)]",
          className
        )}
        onClick={() => setOpen(true)}
      >
        <Plus className='size-5 text-[rgba(152,162,179,1)]' />
      </button>
      {open && (
        <VoiceAddModal
          open={open}
          onOpenChange={setOpen}
          onSave={onSaveVoice}
          loading={saveLoading}
          selectedVoiceIds={voiceIds}
        />
      )}
    </>
  )
}
